module.exports = __webpack_public_path__ + "img/rs-logo.6cb916df.png";